var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',[_c('h1',{staticClass:"text-2xl font-bold"},[_vm._v("Terminal Deployments")])])])}]

export { render, staticRenderFns }